export default __webpack_public_path__ + "static/media/manage-address.0c1d9447.svg";